import { apiFetch } from './client';

export interface QuizRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  ref_number: string;
  name: string;
  description: string | null;
  pass_threshold_pct: number;
  points_on_pass: number;
  admin_email: string | null;
  active: boolean;
  question_count: number;
  created_at: string;
  updated_at: string;
}

export interface QuestionRow {
  id: string;
  quiz_id: string;
  sort_order: number;
  question_text: string;
  recording_id: string | null;
  choices: Array<{ key: string; text: string }>;
  correct_key: string;
  points: number;
  created_at: string;
}

export interface CreateQuizBody {
  name: string;
  description?: string | null;
  pass_threshold_pct?: number;
  points_on_pass?: number;
  admin_email?: string | null;
  customer_id?: string;
}

export type PatchQuizBody = Partial<{
  name: string;
  description: string | null;
  pass_threshold_pct: number;
  points_on_pass: number;
  admin_email: string | null;
  active: boolean;
}>;

export interface CreateQuestionBody {
  question_text: string;
  recording_id?: string | null;
  choices: Array<{ key: string; text: string }>;
  correct_key: string;
  points?: number;
  sort_order?: number;
}

export const quizzes = {
  list: (p: { search?: string; limit?: number; customer_id?: string } = {}) => {
    const q = new URLSearchParams();
    if (p.search) q.set('search', p.search);
    if (p.limit) q.set('limit', String(p.limit));
    if (p.customer_id) q.set('customer_id', p.customer_id);
    return apiFetch<{ rows: QuizRow[] }>(`/api/quizzes?${q}`);
  },
  get: (id: string) => apiFetch<QuizRow>(`/api/quizzes/${id}`),
  create: (body: CreateQuizBody) =>
    apiFetch<QuizRow>('/api/quizzes', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: string, patch: PatchQuizBody) =>
    apiFetch<QuizRow>(`/api/quizzes/${id}`, { method: 'PATCH', body: JSON.stringify(patch) }),
  remove: (id: string) => apiFetch<void>(`/api/quizzes/${id}`, { method: 'DELETE' }),
  listQuestions: (quizId: string) =>
    apiFetch<{ rows: QuestionRow[] }>(`/api/quizzes/${quizId}/questions`),
  createQuestion: (quizId: string, body: CreateQuestionBody) =>
    apiFetch<QuestionRow>(`/api/quizzes/${quizId}/questions`, { method: 'POST', body: JSON.stringify(body) }),
  updateQuestion: (quizId: string, id: string, patch: Partial<CreateQuestionBody>) =>
    apiFetch<QuestionRow>(`/api/quizzes/${quizId}/questions/${id}`, { method: 'PATCH', body: JSON.stringify(patch) }),
  deleteQuestion: (quizId: string, id: string) =>
    apiFetch<void>(`/api/quizzes/${quizId}/questions/${id}`, { method: 'DELETE' }),
};
